import { TouchNavigationService } from 'src/app/nav-overlay/touch-navigation/touch-navigation.service';
import { KeyboardLayout } from '../spell-talker/spell-talker-keyboard/spell-talker-keyboard.model';

export interface NavigationCursorServiceSettings {
  // Movement capture / Vision
  navGuardTimeout: number; // TODO: Deprecated - never used - move to new settings
  cursorFilterTimeout: number; // TODO: Deprecated - never used - move to new settings
  // Touch
  touchRepetitionFilterDuration: number;
  touchFilterDuration: number;
  // Nav Source
  navigationSource: NavigationSource;
  // Scan
  scanInterval: number;
  scanKeyboardLayout: KeyboardLayout; // TODO: mover essa configuração para settings do spell-talker
  // Selection
  dwellDuration: number;

  // NavigationModel
  navigationModel: NavigationModel;
}

export enum NavigationSource {
  vision = 'vision',
  scan = 'scan',
  touch = 'touch',
  eyeTracker = 'eyeTracker',
  colibriEye = 'colibriEye'
}


export const availableNavigationSources = [
  NavigationSource.vision,
  NavigationSource.scan,
  NavigationSource.touch,
  NavigationSource.eyeTracker,
  NavigationSource.colibriEye
];

export enum NavigationModel {
  switch = 'sw',
  unidirectional = '1d',
  //unidirectionalSwitch = '1dsw',
  bidirectional = '2d',
  //bidirectionalSwitch = '2dsw',
  eyeTracker = 'eye',
  //eyeTrackerSwitch = 'eyesw',
  touch = 'touch'
}

export interface NavCursorData {
    event: 'none' | 'cursorPositionChanged'
}

export interface MouseDriverData {
    event: 'none' | 'mouseMoved' | 'mouseClicked',
    coordinates: { x: number; y: number }
    mouseLeftButton?: boolean; // true if the left button is pressed
    mouseRightButton?: boolean; // true if the right button is pressed
    mouseMiddleButton?: boolean; // true if the middle button is pressed
    mouseWheelAbsY?: number; // The 'absolute' position of the mouse wheel, if available
} 